import { useCallback } from 'react';
import { useRouter } from '@backpackjs/storefront';

export const useOkendoScrollToReviews = () => {
  const router = useRouter();

  // used by OkendoStars to scroll to the main reviews section on PDPs
  const scrollToReviews = useCallback(() => {
    try {
      const isProductPage = /\/products\//.test(router.asPath);
      if (!isProductPage) return;

      const reviewsContainer = document.querySelector(
        `[data-comp="ProductReviews"]`
      );
      reviewsContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    } catch (error) {
      // throw new Error(error)
      console.warn('Error while scrolling to reviews form', error.message);
    }
  });

  return {
    scrollToReviews,
  };
};
